// extracted by mini-css-extract-plugin
export default {"taxOffice":"Individual_taxOffice__SDI9p"};